/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { SVGProps } from 'react';

/** Price Shoes brand mark, used as the leading icon of the mobile menu shortcut chips. */
export function PriceShoesMarkIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg fill="currentColor" viewBox="0 0 16 16" aria-hidden="true" {...props}>
            <path d="M14.2251 7.10551C12.6955 4.3688 11.1144 1.79041 9.29809 5.57267C9.22549 5.71473 9.15865 5.89594 9.09027 6.08131C8.92462 6.5304 8.74998 7.00385 8.46281 7.00385V6.99905C8.17565 6.99905 8.00105 6.52564 7.83542 6.07656C7.76704 5.89117 7.7002 5.70994 7.6276 5.56787C5.81124 1.78561 4.2301 4.364 2.70048 7.10071L2.59095 7.29684C2.51575 7.4314 2.44428 7.55928 2.38017 7.67526L2.39179 7.66776L0 11.8829C0.963029 12.479 2.21011 12.4564 3.21328 11.9743C3.69046 11.7768 4.07844 11.4346 4.4341 10.9827C4.62271 10.7431 5.00877 10.08 5.59234 8.99342C5.70194 9.20651 5.80916 9.42753 5.91695 9.64974C6.54804 10.9507 7.19867 12.292 8.46281 12.3159V12.3207C9.72699 12.2968 10.3776 10.9555 11.0087 9.6545C11.8116 7.99941 12.5828 6.40952 14.5455 7.68C14.4796 7.56089 14.4061 7.42926 14.3286 7.29064L14.3281 7.28987L14.2251 7.10551Z" />
            <path d="M16 10.6981C16 11.5942 15.2895 12.3207 14.4132 12.3207C13.5369 12.3207 12.8264 11.5942 12.8264 10.6981C12.8264 9.80197 13.5369 9.07546 14.4132 9.07546C15.2895 9.07546 16 9.80197 16 10.6981Z" />
        </svg>
    );
}
